import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { StorageService } from '../Services/storage.service';
import { HttpQueriesService } from '../Services/http-queries.service';

@Component({
  selector: 'app-congres-virtuel-accreditation',
  templateUrl: './congres-virtuel-accreditation.component.html',
  styleUrls: ['./congres-virtuel-accreditation.component.scss']
})
export class CongresVirtuelAccreditationComponent implements OnInit {

  loginBoxShow = {display:false};

  con_user = null;

  _attestationInt = 1;
  _attestationOwner = {email:null, link1:null, link2:null, link3:null};
  _attestationLoading = false;

  _server = null;

  constructor(private router:Router, private storagedata:StorageService, private httpservice:HttpQueriesService) {
    this.con_user = storagedata.getCongresConUser();
    this._server = httpservice.getServer();
   }

  ngOnInit() {
  }

  showLoginBox(){
    this.con_user ? this.router.navigateByUrl('/congres-virtuel/welcome') : this.loginBoxShow.display = true;
  }

  goToRegisterPage(){
    this.con_user ? alert('Vous êtes déjà connecté!') : this.router.navigateByUrl('/congres-virtuel/auth');
  }

  getAttestation(){
    this._attestationLoading = true;
    this.httpservice.requestAttestation({email:this._attestationOwner.email}).subscribe(v => {
      this._attestationInt = 2;
      this._attestationOwner.link1 = v['att_participation'] ? this._server + "congres_media/attestations/att_participation/" + v['att_participation'] : null;
      this._attestationOwner.link2 = v['att_affiche'] ? this._server + "congres_media/attestations/att_affiche/" + v['att_affiche'] : null;
      this._attestationOwner.link3 = v['att_orale'] ? this._server + "congres_media/attestations/att_orale/" + v['att_orale'] : null;
      this._attestationLoading = false;

    }, err => {
      this._attestationLoading = false;
      (err.error == "notfound") ? alert('Cet email n\'existe pas, veuillez vérifier.') : alert('Erreur de chargement, veuillez réessayer!');
    })
  }

}
